var _path, _path2, _path3, _path4, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarketplace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 24H84V76C84 78.2091 82.2091 80 80 80H13C10.7909 80 9 78.2091 9 76V24Z",
    fill: "#12D9E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 80V54C21 52.3431 22.3431 51 24 51H41C42.6569 51 44 52.3431 44 54V80",
    stroke: "#383434"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7442 10H5.7931C4.25051 10 3 11.2505 3 12.7931V26.1279C3 32.1324 7.8676 37 13.8721 37C19.8766 37 24.7442 32.1324 24.7442 26.1279V26.3929C24.7442 32.251 29.6118 37 35.6163 37C41.6208 37 46.4884 32.251 46.4884 26.3929C46.4884 32.251 51.356 37 57.3605 37C63.365 37 68.2326 32.251 68.2326 26.3929V27.1163C68.2326 32.5749 72.6577 37 78.1163 37C83.5749 37 88 32.5749 88 27.1163V12.7931C88 11.2505 86.7495 10 85.2069 10H24.7442Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4884 22.5357V26.3929M46.4884 26.3929C46.4884 32.251 41.6208 37 35.6163 37C29.6118 37 24.7442 32.251 24.7442 26.3929V22.5357V26.1279C24.7442 32.1324 19.8766 37 13.8721 37V37C7.8676 37 3 32.1324 3 26.1279V12.7931C3 11.2505 4.25051 10 5.7931 10H24.7442H85.2069C86.7495 10 88 11.2505 88 12.7931V27.1163C88 32.5749 83.5749 37 78.1163 37V37C72.6577 37 68.2326 32.5749 68.2326 27.1163V22.5357V26.3929C68.2326 32.251 63.365 37 57.3605 37C51.356 37 46.4884 32.251 46.4884 26.3929Z",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 57.5,
    y: 42.5,
    width: 19,
    height: 18,
    rx: 3.5,
    fill: "white",
    stroke: "#383434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketplace);
export default __webpack_public_path__ + "static/media/marketplace.fe68413c1f2825770698c74c5ed17309.svg";
export { ForwardRef as ReactComponent };